"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Divider = _interopRequireDefault(require("../../atoms/dividers/Divider"));

var _OverflowMenuItem = _interopRequireDefault(require("./OverflowMenuItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    menu: {
      "& .MuiMenu-paper": {
        boxShadow: "0 2px 8px rgba(0,0,0,.16)",
        borderRadius: 6
      }
    },
    menuList: {
      paddingTop: 0,
      paddingBottom: 0,
      "& .MuiDivider-root": {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        "&:last-child": {
          display: "none"
        }
      }
    }
  };
});
/**
 * ** Overflow menus display a list of choices on temporary cards. **
 */

var OverflowMenuContainer = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var anchorEl = _ref.anchorEl,
      setAnchorEl = _ref.setAnchorEl,
      menuItems = _ref.menuItems;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Menu, {
    ref: ref,
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: function onClose() {
      return setAnchorEl(null);
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    getContentAnchorEl: null,
    MenuListProps: {
      component: "div",
      className: styles.menuList
    },
    className: styles.menu
  }, menuItems.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      onClick: function onClick() {
        return setAnchorEl(null);
      }
    }, "  ", item, " "), index < menuItems.length && /*#__PURE__*/_react.default.createElement(_Divider.default, {
      color: "greyTwo"
    }));
  }));
});

OverflowMenuContainer.propTypes = {
  /** The menu anchor point */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /** Children element to wrap up the menu */
  menuItems: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node]),

  /** Action to call on the close (clear anchorEl) */
  setAnchorEl: _propTypes.default.func.isRequired,
  ref: _propTypes.default.any
};
OverflowMenuContainer.defaultProps = {
  anchorEl: null,
  menuItems: null
};
var _default = OverflowMenuContainer;
exports.default = _default;